// OK 23/10/2024

import { Customers } from "../interfaces/customers.interface";
import { ObjectId } from "../types";
import { ip } from "./../utils/setup";

const CUSTOMERS_API = `${ip}/api/Customers`;
// GET

export async function getCustomer(_id: ObjectId): Promise<Customers> {
    const response = await fetch(`${CUSTOMERS_API}/${_id}`, {
        credentials: "include" 
    });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error("Erreur de serveur lors de la réception du client.");
  }
}

export async function getCustomers(): Promise<Customers[]> {
    const response = await fetch(CUSTOMERS_API, {
        credentials: "include" 
    });
  if (response.ok) {
    const body: Customers[] = await response.json();
    return body;
  } else {
    throw new Error("Erreur du serveur lors de la réception des clients.");
  }
}

export async function getCustomersName() {
  try {
      const response = await fetch(CUSTOMERS_API + "/NameCustomers", {
          credentials: "include" 
      });
    if (response.ok) {
      return response.json();
    } else {
      if (response.status === 500) {
        throw new Error(
          `Connexion au serveur impossible, code serveur: ${response.status}`
        );
      } else if (response.status === 404) {
        throw new Error(
          `Client introuvable, assurez vous de posséder un client dans votre base de données, code serveur : ${response.status}`
        );
      } else {
        throw new Error(`Problème serveur, code serveur: ${response.status}`);
      }
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

export async function getCustomersNoHiden() {
  try {
      const response = await fetch(CUSTOMERS_API + "/noHiden", {
          credentials: "include" 
      });
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(
        `Connexion au serveur impossible, code serveur: ${response.status}`
      );
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

export async function getCustomersHiden() {
  try {
      const response = await fetch(CUSTOMERS_API + "/Hiden", {
          credentials: "include" 
      });
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(
        `Connexion au serveur impossible, code serveur: ${response.status}`
      );
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

// GET ID

// POST

export async function createCustomer(
  newCustomer: Partial<Customers>
): Promise<Customers> {
  const response = await fetch(CUSTOMERS_API, {
      method: "POST",
      credentials: "include" ,
    headers: {
        "content-type": "application/json",
       
    },
    body: JSON.stringify(newCustomer),
  });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error(" Erreur lors de la création du nouveau client.");
  }
}

//PUT

export async function updateCustomer(updateCustomer: Customers) {
  const { globalError, ...restCustomer } = updateCustomer;
  const response = await fetch(`${CUSTOMERS_API}/${restCustomer.idCustomer}`, {
      method: "PUT",
      credentials: "include" ,
      headers: { "Content-Type": "application/json" },
    body: JSON.stringify(restCustomer),
  });
  if (response.ok) {
    return response.ok;
  } else {
    throw new Error("Erreur lors de la modification du client.");
  }
}

// DELETE

export async function deleteCustomer(_id: ObjectId): Promise<ObjectId> {
  const response = await fetch(`${CUSTOMERS_API}/${_id}`, {
      method: "DELETE",
      credentials: "include" 
      
  });
  if (response.ok) {
    return _id;
  } else {
    throw new Error("Erreur lors de la mise en archive du client.");
  }
}
